export const orgRound = (value, base) => {
  return Math.round(value * base) / base;
}

export const getDocuments = (collection) => {
  return collection && collection.docs && collection.docs.map(v => v.data())
}
